'use client'

import React from 'react'
import { useLocale, useTranslations } from 'next-intl'

import type { HolidayPackageSummary } from '@/src/types/holidays'
import { formatHolidayTripWindow } from '@/src/utils/holidays'

import PackageSummary, { type PackageSummaryFact } from './packageSummary'

interface PackageSummaryWrapperProps {
    summary: HolidayPackageSummary
    isMobile: boolean
}

const PackageSummaryWrapper: React.FC<PackageSummaryWrapperProps> = ({ summary, isMobile }) => {
    const t = useTranslations('holidaysPage')
    const locale = useLocale()

    const facts: PackageSummaryFact[] = []
    if (summary.durationDays) {
        facts.push({ key: 'duration', icon: 'duration', value: t('durationDays', { count: summary.durationDays }) })
    }
    if (summary.airline?.name) {
        facts.push({ key: 'airline', icon: 'airline', value: summary.airline.name })
    }
    facts.push({
        key: 'dates',
        icon: 'dates',
        value: t('groupTripOn', { window: formatHolidayTripWindow(summary.startDate, summary.endDate, locale) })
    })

    return (
        <PackageSummary
            destinationName={summary.destinationName}
            tagline={summary.tagline}
            tourPackageLabel={t('tourPackage')}
            facts={facts}
            tags={summary.tags ?? []}
            isMobile={isMobile}
        />
    )
}

export { PackageSummaryWrapper }
export default PackageSummaryWrapper
